import { CommonConstants } from "@assets/constants";
import { Commodity } from "@assets/types";

import { ArrayUtilities, LabelMapperUtilities } from ".";

export const getShipmentTemperatures = (commodity: Commodity) => {
  if (
    commodity &&
    commodity.LowerTemperature !== null &&
    commodity.HigherTemperature !== null
  ) {
    const temperatureOptions = LabelMapperUtilities.listToSelectOptionMapper(
      ArrayUtilities.range(
        commodity.LowerTemperature,
        commodity.HigherTemperature
      )
    );
    return temperatureOptions;
  } else {
    return CommonConstants.defaultCargoTemperatureOptions;
  }
};
